import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement, LightDomStyles } from '@phase2/outline-core';
import { customElement } from 'lit/decorators.js';
import componentStyles from './outline-styled-table.css.lit';

/**
 * The OutlineStyledTable component
 * @element outline-styled-table
 */
@customElement('outline-styled-table')
export class OutlineStyledTable extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  lightDomStyles = new LightDomStyles(this, [componentStyles]);

  render(): TemplateResult {
    return html` <slot></slot> `;
  }
}
